import { __exports as time } from "../../../../../../_virtual/time.js";
var hasRequiredTime;
function requireTime() {
  if (hasRequiredTime) return time;
  hasRequiredTime = 1;
  Object.defineProperty(time, "__esModule", { value: true });
  time.sleep = void 0;
  const sleep = (millis) => {
    if (millis === 0) {
      return;
    }
    return new Promise((resolve) => setTimeout(resolve, millis));
  };
  time.sleep = sleep;
  return time;
}
export {
  requireTime as __require
};
//# sourceMappingURL=time.js.map
